import http from "../../api";

export default {
  namespaced: true,
  actions: {
    smsCodeGet({}, body) {
      return http.post("/admin-tools/get-sms-code", body);
    },
    ["search-sms-user"]({}, login) {
      return http.get("/admin-tools/search-sms-user/" + login);
    },
    permissionsGet({}, body) {
      return http.post("/Role/Permissions", body);
    },
    accessChange({}, body) {
      return http.post("/Role/ChangeAccess", body);
    },
    userRolesGet({}, body) {
      return http.post("/admin-tools/roles", body);
    },
    rolesGet() {
      return http.get("/admin-tools/roles");
    },
    roleChange({}, body) {
      return http.post("/admin-tools/role", body);
    },
    staffGet({}) {
      return http.get("/admin-tools/staff");
    },
    ["staff/delete"]({}, { UserGuid }) {
      return http.delete("/admin-tools/staff/" + UserGuid);
    },
    ["staff/add"]({}, { UserGuid, roleIds }) {
      console.log(roleIds);
      return http.put("/admin-tools/staff/" + UserGuid, {
        RolesId: roleIds.map(item => item)
      });
    },
    ["staff/get"]({}, { UserGuid }) {
      return http.get("/admin-tools/staff/" + UserGuid);
    },

    permissionsGetNew({}) {
      return http.get("/admin-tools/permissions");
    },
    rolesGetNew({}) {
      return http.get("/admin-tools/roles");
    },
    rolePermissionsGet({}, RoleId) {
      return http.get("/admin-tools/permission/" + RoleId);
    },
    rolePermissionsSet({}, { RoleId, ...body }) {
      return http.post("/admin-tools/permission/" + RoleId, body);
    },
    setPassword(
      {},
      {
        User: { UserGuid },
        Password
      }
    ) {
      return http.put("/customer/password/" + UserGuid, { Password });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/admin-tools.js